import { formatMoney, formatPercent } from '@/modules/utils';
import DatePicker from '@/components/common/date-picker';
import NAccordionChart from '@/components/common/n-accordion-chart';
import IndexChart from './chart';
import moment from 'moment';

export default {
  props: {
    indexId: {
      type: String,
      default: 'trend'
    },

    data: {
      type: Object,
      default: null
    },

    showStyle: {
      type: Boolean,
      default: false
    }
  },

  components: {
    DatePicker,
    IndexChart,
    NAccordionChart
  },

  data() {
    return {
      deadline: 1,

      inquiry_date: '',
      inquiry_valid: true,
      inquiry_value: '',

      gloss_texts_trend: [
        'Bisherige Wertentwicklungen liefern keinen Hinweis auf zukünftige Renditen.',
        'Die Höhe der Zielvolatilität wird jedes Jahr neu festgelegt. Rechtzeitig vor dem Indexstichtag informieren wir über die Höhe der Zielvolatilität für das nächste Jahr.',
        'Der Indexstand wird in Punkten angegeben (Basiswert sind 100 Punkte).',
        'Die Jahresrendite ist das Verhältnis des Kurses im aktuellen Monat zum Kurswert vor dem Indexstichtag. Positive und negative Wertentwicklungen fließen in den Index ein – es gibt keine Renditeobergrenze. Vor Vollendung des Jahres ist die angegebene Rendite unverbindlich.',
        'Die maßgebliche Jahresrendite ist das Verhältnis des Kurses am Ende des Indexjahres zum Kurswert vor dem Indexstichtag. Ist die Jahresrendite nicht positiv, wird die maßgebliche Jahresrendite auf 0 % gesetzt- Sie haben so kein Verlustrisiko des vorhandenen Kapitals.'
      ],

      gloss_texts_vip_euro: [
        'Bisherige Wertentwicklungen liefern keinen Hinweis auf zukünftige Renditen.',
        'Bisherige Wertentwicklungen liefern keinen Hinweis auf zukünftige Renditen. <br>Die Höhe des Caps wird jedes Jahr neu festgelegt. Rechtzeitig vor dem Indexstichtag informieren wir über die Höhe des Caps für das nächste Jahr.',
        'Die maßgebliche Indexrendite errechnet sich aus der Summe der monatlichen positiven und negativen Wertentwicklungen des Aktienindex inklusive Cap. Ist die Summe der maßgeblichen Monatsrenditen nicht positiv, wird die Rendite auf 0 gesetzt',
        'Die Summe der monatlichen Beteiligung ergibt sich aus der Addition der monatlichen positiven und negativen Wertentwicklungen des Aktienindex inklusive Cap. <br>Vor Vollendung des Indexjahres ist die angegebene Performance unverbindlich.'
      ],

      year_: 0,
      month_names: moment.months()
    };
  },

  computed: {
    apiRequest () {
      return this.$parent.apiRequest;
    },

    config () {
      return this.$parent.config;
    },

    currentIndex () {
      const tab = this.$parent.product_variant_;

      return tab && tab.id
        ? tab.id
        : '';
    },

    pdfRequestUrl() {
      const paths = this.config.paths;

      return {
        'trend-old': paths.trend_create_pdf, // Trend
        'deka-old': paths.deka_create_pdf, // Deka
        'climate-old': paths.climate_create_pdf, // Climate
      };
    }
  },

  created () {
    if (this.config.index_name || this.currentIndex === this.indexId) {
      this.loadIndexConfig();
    }
  },

  methods: {
    isBeforeJune (deadline, year) {
      const currentYear = moment().year();
      const currentMonth = moment().month() + 1;

      if (year > currentYear) {
        return true;
      }

      if (deadline === 2) {
        return false;
      }

      return currentYear === year && currentMonth < 6;
    },

    getFileNameFromHeader(header, defaultName = '') {
      const contentDisposition = header['content-disposition'];

      if (!contentDisposition) {
        return defaultName;
      }

      const match = contentDisposition.match(/filename=(.*)/);

      return match && match.length > 1
        ? match[1].replace(/"/g, '')
        : defaultName;
    },

    onSelectInquiryDate(value) {
      this.inquiry_date = value;
      this.inquiry_valid = true;
    },

    onSelectYear(value) {
      this.year_ = value;
      this.loadDetails();
    },

    onCreatePdf() {
      let year_ = parseInt(this.year_);

      if (!year_ || isNaN(year_)) {
        return;
      }

      let request_uri = this.pdfRequestUrl[this.indexId];

      const params = {
        year: year_,
        data_type: this.deadline
      };

      if (this.indexId === 'deka-old' || this.indexId === 'climate-old') { // pass 'j' or 'd' for deka and climate
        params.data_type = this.deadline_id;
      }

      params.anticache = moment().format('YYYYMMDDHHmmss');

      this.apiRequest.get(request_uri, {
        params,
        responseType: 'blob'
      })
        .then(res => {
          this.downloadBlob(res.data);
        });
    },

    onOpenFactsheet(path) {
      const cache_str = moment().format('YYYYMMDDHHmmss');
      const pdf_url = `${ this.config.media_base_url }${ path }?anticache=${ cache_str }`;
      window.open(pdf_url, '_blank');
    },

    downloadBlob(blob, fileName = 'spv_index.pdf') {
      const a = document.createElement('a');

      document.body.appendChild(a);

      a.style.display = 'none';
      a.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        a.href = window.URL.createObjectURL(blob);
        a.download = fileName;
        a.click();
      }

      document.body.removeChild(a);
    },

    formatDate(value, format = 'DD.MM.YYYY') {
      if (!moment(value).isValid()) {
        return '';
      }

      return moment(value).format(format);
    },

    formatPercent(value, decimals) {
      if (value === null) {
        return '';
      }

      let value_ = parseFloat(value);
      if (isNaN(value_)) {
        return '';
      }

      return `${ formatPercent(value, decimals) }%`;
    },

    formatMoney
  },

  watch: {
    currentIndex () {
      if (this.currentIndex === this.indexId) {
        this.loadIndexConfig();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/apps/index/mixin.js